export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5907.18b93d2b.jpg";